import Vue from "vue";
import VueSimpleSpinner from "vue-simple-spinner";
import {Task as TaskModel} from "@/interfaces/TaskInterfaces";
import {HTTP} from "@/utils/httpCommonUtil";
import FacilityAndSpecialtySelector from "@/componentsReusable/FacilityAndSpecialtySelector.vue";
import flatPickr from "vue-flatpickr-component";
import {BallPulseLoader} from "vue-loaders";
import {getRestParamErrorMessage, getRestResponseErrorMessage} from "@/utils/serverErrorMessageUtil";

export default Vue.component('create-special-invoice', {
  name: 'CreateSpecialInvoice',
  components: {
    VueSimpleSpinner,
    FacilityAndSpecialtySelector,
    flatPickr,
    BallPulseLoader
  },
  data() {
    return {
      loadingTemplates: false,
      savingInvoice: false,
      templates: [] as any,
      templateId: null,
      templateName: '',
      templateErrorMessage: '',
      facilityId: null as any,
      facilityErrorMessage: '',
      specialtyId: null as any,
      specialtyErrorMessage: '',
      invoiceStartDate: null as any,
      invoiceStartDateErrorMessage: '',
      invoiceEndDate: null as any,
      invoiceEndDateErrorMessage: '',
      timeout: 0 as number,
      showDetails: false
    }
  },
  async created() {
    await this.loadTemplates();
  },
  methods: {
    facilitySelected(facility: any) {

      if (this.facilityId !== facility.id) {
        this.facilityId = facility.id;
        this.specialtyId = null;
      }
    },
    updateSpecialtyId(specialty: any) {
      this.specialtyId = specialty.specialtyId;
    },
    escapeListener(evt: any) {
      if (evt.key === 'Escape') {
        this.cancel();
      }
    },
    cancel() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.$emit('cancel-event');
    },
    async loadTemplates() {
      this.loadingTemplates = true;
      try {
        const response = await HTTP.get('/api/special-invoice-templates');
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving special invoice templates.");
        }
        this.templates = response.data.data;
        this.loadingTemplates = false;
      } catch (err) {
        console.log(err);
        this.loadingTemplates = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching special invoice templates.'
        });
      }

    },
    storeShowDetailsState(task: TaskModel) {
      this.showDetails = task.showDetails;
    },
    templateSelected() {
      for (const template of this.templates) {
        if (this.templateId === template.id) {
          this.facilityId = template.facilityId;
          this.specialtyId = template.specialtyId;
        }
      }
    },
    async generateInvoice() {
      this.savingInvoice = true;
      try {
        const toSave = {
          specialInvoiceTemplateId: this.templateId,
          facilityId: this.facilityId,
          specialtyId: this.specialtyId,
          invoiceStartDate: this.invoiceStartDate,
          invoiceEndDate: this.invoiceEndDate
        };
        const response = await HTTP.post('/api/special-invoices', toSave);
        if (!response.data || !response.data.data) {
          throw new Error('An error occurred creating special invoice.');
        }
        const invoiceId = response.data.data.invoiceId;
        this.$router.push({name: 'Invoice', params:{invoiceId: invoiceId}});
      } catch (err) {
        this.templateErrorMessage = getRestParamErrorMessage(err, 'specialInvoiceTemplateId');
        this.facilityErrorMessage = getRestParamErrorMessage(err, 'facilityId');
        this.specialtyErrorMessage = getRestParamErrorMessage(err, 'specialtyId');
        this.invoiceStartDateErrorMessage = getRestParamErrorMessage(err, 'invoiceStartDate');
        this.invoiceEndDateErrorMessage = getRestParamErrorMessage(err, 'invoiceEndDate');
        if (
          !this.templateErrorMessage &&
          !this.facilityErrorMessage &&
          !this.specialtyErrorMessage &&
          !this.invoiceStartDateErrorMessage &&
          !this.invoiceEndDateErrorMessage
        ) {
          let generalError = getRestResponseErrorMessage(err);
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Creating Special Invoice',
            text: generalError ? generalError : 'An error occurred creating special invoice.',
            // duration: 5000
          });
        }
      } finally {
        this.savingInvoice = false;
      }
    }
  }

});



// WEBPACK FOOTER //
// ./src/components/invoices/special/CreateSpecialInvoice.ts